import { withStyles, Container, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "./styles";
import Breadcrumbs from "../../components/Breadcrumbs";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import * as generalActions from "../../actions/general";
import ProjectItem from "../../components/ProjectItem";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactPlaceholder from "react-placeholder";
import ProjectPlaceholder from "../../components/Home/ProjectComponent/ProjectPlaceholder";
import Seo from "../../components/Seo";

function Project(props) {
  const {
    item,
    classes,
    generalActionCreators,
    projects,
    pages,
    loading
  } = props;
  const { fetchProjectById, fetchAllProject } = generalActionCreators;
  const [page, setPage] = useState(1);

  const seoData = {
    seo_title: "Các dự án hoàn thành và đưa vào sử dụng",
    seo_description: "Đây là những dự án chúng tôi đã hoàn thành và đưa vào sử dụng thành công",
    name: "Công ty TNHH thiết kế và lập trình website, app mobile WASTH"
  }


  useEffect(() => {
    if (item) {
      fetchProjectById({ id: item.id, page: 1 });
    } else {
      fetchAllProject({ page: 1 });
    }
  }, [fetchProjectById, fetchAllProject, item]);

  const mapParams = () => {
    let params = [{ name: "Dự án", cate: "project", to: "/du-an" }];

    if (item) {
      params.push({
        name: item.name,
        cate: "project-child",
        to: item.alias
      });
    }

    return params;
  };

  const renderProject = () => {
    if (projects && projects.length > 0) {
      return projects.map(item => <ProjectItem key={item.id} item={item} />);
    }
  };

  const renderMore = () => {
    if (item) {
      fetchProjectById({ id: item.id, page: page + 1 });
    } else {
      fetchAllProject({ page: page + 1 });
    }
    setPage(page + 1);
  };

  return (
    <>
      <Seo seoContent={item && item.seo_title !== null ? item : seoData}/>
      <Breadcrumbs params={mapParams()} />
      <Container >
        <ReactPlaceholder
          ready={!loading}
          showLoadingAnimation={true}
          customPlaceholder={<ProjectPlaceholder />}
        >
          <div></div>
        </ReactPlaceholder>
        <InfiniteScroll
          className={classes.container}
          dataLength={projects.length}
          next={renderMore}
          hasMore={pages > 1 && pages > page - 1 ? true : false}
          loader={
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          }
        >
          {renderProject()}
        </InfiniteScroll>
      </Container>
    </>
  );
}
const mapStateToProps = state => ({
  projects: state.general.projects,
  pages: state.general.pages,
  loading: state.general.loading,
  currentPage: state.general.currentPage
});

const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalActions, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(Project);
